export const ReportEnum = {
  Summary: 0,
  Detail: 1,
  SelectionList: 2,
  SelectionSummary: 3,
  NoReport: 4,
};
export const Nov15thStatusEnum = {
  YesCompletedByNov15th: 0,
  YesCompletedAfterNov15th: 1,
  NoVerificationNotPerformedOrCompleted: 2,
};



// WEBPACK FOOTER //
// ./src/pages/verificationreport/helpers/constants.js